import React, { useState, useEffect } from 'react';

function ReadingProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let ticking = false;

    const updateProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Debug logging
      console.log('📊 Progress Debug:', {
        windowHeight,
        documentHeight,
        scrollTop,
        scrollableHeight: documentHeight - windowHeight,
        calculatedProgress: scrollTop / (documentHeight - windowHeight) * 100
      });
      
      // Calculate progress percentage
      const scrollableHeight = documentHeight - windowHeight;
      
      // Avoid division by zero
      if (scrollableHeight <= 0) {
        console.log('⚠️ Scrollable height is 0 or negative');
        setProgress(0);
      } else {
        const scrolled = (scrollTop / scrollableHeight) * 100;
        const finalProgress = Math.min(Math.max(scrolled, 0), 100);
        console.log('✅ Setting progress to:', finalProgress);
        setProgress(finalProgress);
      }
      
      ticking = false;
    };

    const requestTick = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateProgress);
        ticking = true;
      }
    };

    // Add scroll listener with passive flag for better performance
    window.addEventListener('scroll', requestTick, { passive: true });
    
    // Add resize listener to recalculate on window resize
    window.addEventListener('resize', requestTick, { passive: true });
    
    // Initial calculation with small delay to ensure content is loaded
    const timer = setTimeout(updateProgress, 100);

    return () => {
      window.removeEventListener('scroll', requestTick);
      window.removeEventListener('resize', requestTick);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="reading-progress-container">
      <div
        className="reading-progress-bar"
        style={{ width: `${progress}%` }}
        role="progressbar"
        aria-valuenow={Math.round(progress)}
        aria-valuemin="0"
        aria-valuemax="100"
        aria-label="Reading progress"
      />
    </div>
  );
}

export default ReadingProgress;